/** Kannada: a signed job's progress line, the actions on a job restored from the record, and notifications. */
export const progress = {
    "progress.title": "ಕೆಲಸದ ಪ್ರಗತಿ",
    "progress.agreed": "ಒಪ್ಪಿಗೆ",
    "progress.on_my_way": "ದಾರಿಯಲ್ಲಿ",
    "progress.started": "ಶುರುವಾಯಿತು",
    "progress.done": "ಮುಗಿದಿದೆ",
    "progress.paid": "ಹಣ ಪಾವತಿ",
    "progress.closed": "ಮುಕ್ತಾಯ",
    "progress.cancelled": "ರದ್ದು",
    "progress.you": "ನೀವು",
    "progress.more.one": "ಇನ್ನೂ {count} ಹಂತ",
    "progress.more.other": "ಇನ್ನೂ {count} ಹಂತಗಳು",
    "progress.less": "ಕಡಿಮೆ ತೋರಿಸಿ",
    "restored.work_done": "ಕೆಲಸ ಮುಗಿದಿದೆ",
    "restored.cancel": "ಈ ಕೆಲಸ ರದ್ದುಮಾಡಿ",
    "restored.why": "ಈ ಕೆಲಸ ನಿಮ್ಮ GigSync ದಾಖಲೆಯಿಂದ ಮರಳಿ ಬಂದಿದೆ, ಹಾಗಾಗಿ ಬದಲಾವಣೆ ದಾಖಲೆಯ ಮೂಲಕ ಒಂದು ನಿಮಿಷದಲ್ಲಿ {name} ಅವರಿಗೆ ತಲುಪುತ್ತದೆ.",
    "restored.cancel_sure": "ಈ ಕೆಲಸವನ್ನು ನಿಮ್ಮಿಬ್ಬರಿಗೂ ರದ್ದುಮಾಡಬೇಕೇ?",
    "restored.cancel_yes": "ಹೌದು, ರದ್ದುಮಾಡಿ",
    "restored.keep": "ಇರಲಿ",
    "alerts.title": "ಸೂಚನೆಗಳು",
    "alerts.about": "ಕೆಲಸ ಮುಂದುವರಿದಾಗ ಈ ಫೋನ್‌ಗೆ ಸೂಚನೆ, ಯಾರಿಂದ ಮತ್ತು ಏನಾಯಿತು ಎಂದು: ಹೊಸ ವಿನಂತಿ, ಒಪ್ಪಂದಕ್ಕೆ ಸಹಿ, ದಾರಿಯಲ್ಲಿ, ಮುಗಿದಿದೆ, ಹಣ ಪಾವತಿ ಅಥವಾ ರದ್ದು. ಹೇಳಿದ ಮಾತು ಎಂದಿಗೂ ಕಾಣಿಸುವುದಿಲ್ಲ, ಮತ್ತು ದಾರಿಯಲ್ಲಿ Google ಅಥವಾ Apple ಇದನ್ನು ಓದಲಾರವು.",
    "alerts.on": "ಆನ್: ಸೂಚನೆಗಳು ಈ ಫೋನ್‌ಗೆ ಬರುತ್ತವೆ.",
    "alerts.turn_on": "ಸೂಚನೆಗಳನ್ನು ಆನ್ ಮಾಡಿ",
    "alerts.turn_off": "ಆಫ್ ಮಾಡಿ",
    "alerts.blocked": "ಈ ಬ್ರೌಸರ್‌ನಲ್ಲಿ GigSync ಸೂಚನೆಗಳು ತಡೆಹಿಡಿಯಲಾಗಿದೆ. ಈ ಸೈಟ್‌ನ ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್‌ನಲ್ಲಿ ಅನುಮತಿಸಿ, ನಂತರ ಇಲ್ಲಿಗೆ ಬನ್ನಿ.",
    "alerts.install": "iPhone ನಲ್ಲಿ ಸೂಚನೆಗಳು ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ನ GigSync ಆ್ಯಪ್‌ನಲ್ಲಿ ಬರುತ್ತವೆ. Share ಇಂದ ಸೇರಿಸಿ, ಅಲ್ಲಿಂದ ತೆರೆಯಿರಿ, ನಂತರ ಸೂಚನೆಗಳನ್ನು ಆನ್ ಮಾಡಿ.",
    "alerts.unsupported": "ಈ ಬ್ರೌಸರ್ GigSync ಸೂಚನೆಗಳನ್ನು ತೋರಿಸಲಾಗದು.",
    "alerts.unavailable": "GigSync ನಲ್ಲಿ ಸೂಚನೆಗಳು ಇನ್ನೂ ಶುರುವಾಗಿಲ್ಲ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
};
//# sourceMappingURL=progress.js.map